module.exports = __webpack_public_path__ + "common/icon-add-6a2254600c2278d208d8fc4326187163.svg";